export default {
  offline: !navigator.onLine,
  loading: false,
  serviceWorkerStatus: null,
};
